// frontend/src/routes/RequirePermission.js
// Shows children only if the signed-in user has the permission. The backend
// enforces the same permission on every route; this only hides screens.

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { AccessDenied } from '../components/layout/SystemState';

const RequirePermission = ({ permission, children }) => {
    const { can } = useAuth();

    if (!can(permission)) {
        // No redirect: a redirect home could loop when no permissions are loaded
        return <AccessDenied />;
    }

    return children;
};

export default RequirePermission;
